import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { SelectAllocationType, PaymentInstructions } from '../components';
import { selectAccountBalance, selectAutoInvest } from '../../auth/ducks';
import {checkGeneralContractDateActions,selectCheckGeneralContract } from '../../account-management/ducks';
import { bindActionCreators } from 'redux';
import { apiCallIds as accountApiCallIds } from '../../../features/account-management/api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectAccount, selectAccountId, selectNextUnsignedContract } from '../../../features/auth/ducks';
import { Spin } from 'antd';


const mapStateToProps = state => ({
  accountBalance: selectAccountBalance(state),
  autoinvest: selectAutoInvest(state),
  accountId: !!selectAccount(state) ? selectAccountId(state) : '',
  checkedContractDate: selectCheckGeneralContract(state),
  isChecking: selectIsInProgress(state, accountApiCallIds.CHECK_GENERAL_CONTRACT_DATE ),
  contract: selectNextUnsignedContract(state),
});

const mapDispatchToProps = dispatch => ({
  goTo: pathname => dispatch(push({ pathname })),
  actions: bindActionCreators(
    {
      checkGeneralContractDate: checkGeneralContractDateActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class CreateAllocationContainer extends Component {
  static propTypes = {
    goTo: PropTypes.func.isRequired,
    accountBalance: PropTypes.number.isRequired,
  };

  componentDidMount() {
    const { accountId, actions } = this.props;
    if (accountId){
      actions.checkGeneralContractDate({
        accountId,
      })
    }
  }

  componentDidUpdate(prevProps, prevState){
    // had to refresh whole site, because we need to trigger change in dashboard component - seperate from this one
    if(this.props.checkedContractDate !== prevProps.checkedContractDate && this.props.checkedContractDate === true){

      window.location.href = '#/dashboard/overview'
      window.location.reload()
    }
  }

  selectManualAllocation = () => {
    this.props.goTo('/dashboard/create-investment/manual');
  };

  selectAutomaticAllocation = () => {
    this.props.goTo('/dashboard/create-investment/automatic');
  };

  render() {
    const { accountBalance, isChecking, autoinvest } = this.props;

    return (
      <Spin spinning={isChecking}>
        <section className="allocations-wrapper">
          {!!accountBalance && (
            <SelectAllocationType
              selectManualAllocation={this.selectManualAllocation}
              selectAutomaticAllocation={this.selectAutomaticAllocation}
              autoinvest={autoinvest}
            />
          )}
          <PaymentInstructions />
        </section>
      </Spin>

    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/containers/CreateAllocationContainer.js